export const Props = () => ({
  //--------------------------------------------------------------------------
  //                     Включена / Выключена switch кнопка
  //--------------------------------------------------------------------------
  isOn:{
    type: Boolean,
    default: false,
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
})
